export default {
  general: {
    settings: "Configurações",
    show_time: "Mostrar exibição de hora",
    show_seconds: "Mostrar segundos",
    show_search: "Mostrar barra de pesquisa",
    show_wallpaper: "Mostrar botão de pular papel de parede",
    show_bookmark: "Mostrar botão de favoritos",
    show_weather: "Mostrar clima",
    show_top_sites: "Mostrar sites frequentemente visitados",
    auto_change_background: "Alterar plano de fundo automaticamente",
    auto_change_every: "Alterar a cada",
    days: "dias",
    hours: "horas",
    minutes: "minutos",
    interval_required: "Dias, horas e minutos não podem ser todos 0",
    sync_enabled: "Sincronização em nuvem de tarefas",
    show_ai_chat: "Mostrar botão de chat com IA",
  },
  profile: {
    title: "Perfil",
    logout: "Sair",
    sign_in: "Entrar",
    sign_in_desc: "Por favor, faça login para desbloquear a experiência completa",
    avatar_updated: "Avatar atualizado com sucesso",
    nickname_updated: "Apelido atualizado com sucesso",
    avatar_size: "O tamanho do arquivo do avatar não deve exceder 500KB",
    login_required: "Você deve estar conectado para atualizar seu avatar",
    login_success: "Login bem-sucedido",
    user_avatar: "Avatar do usuário",
    edit_avatar: "Editar avatar",
    save: "Salvar",
    cancel: "Cancelar"
  },
  subscription: {
    title: "Assinatura",
    check: "Verificar minha assinatura",
    upgrade: "Atualizar assinatura",
    subscribe: "Assinar Tabby",
    expired_on: "Expirado em: {0}",
    expires_on: "Expira em: {0}",
    plans: {
      premium: "Desbloqueie tudo no Tabby: papéis de parede ilimitados, fundos personalizados e coleções exclusivas.",
      pro: "Atualize sua assinatura para desbloquear papéis de parede ilimitados, fundos personalizados e coleções exclusivas.",
      free: "Assine para desbloquear papéis de parede ilimitados, fundos personalizados e coleções exclusivas."
    }
  },
  wallpaper: {
    title: "Papel de parede",
    upload: "Carregar fundo personalizado",
    upgrade_required: "Atualize para o plano Pro/Premium para desbloquear o recurso de fundo personalizado",
    images: "Imagens",
    hues: "Tonalidades",
    anims: "Animações",
    diy: "Personalizado",
    get_new: "Obter novo",
    upload_background: "Carregar fundo",
    add: "Adicionar",
    remote_url: "URL de imagem remota",
    size_tip: "Arquivos de fundo menores carregam abas mais rapidamente. A maioria dos navegadores tem um limite de tamanho de arquivo de 1,5MB. URLs remotas não têm restrições.",
    please_login: "Por favor, faça login primeiro",
    click_to_upload: "Clique para carregar",
    video_gif_image: "vídeo, GIF ou imagem",
    background: "fundo",
    or_enter_remote_background_url: "Ou insira URL de fundo remoto",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "Fundo personalizado removido",
    failed_to_load_background: "Falha ao carregar fundo",
    using_default: "Usando fundo padrão em vez disso",
    insufficient_storage: "Armazenamento insuficiente",
    upload_failed: "Falha no upload",
    success: "Sucesso",
    remote_background_added: "Fundo remoto adicionado",
    detecting_media_type: "Detectando tipo de mídia...",
    invalid_media_type: "Tipo de mídia não reconhecido",
    video_load_failed: "O vídeo não pode ser carregado, verifique se a URL está correta"
  },
  rewards: {
    title: "Recompensas",
    invite_friends: "Convidar amigos",
    get_access: "Convide amigos e desbloqueie descontos no Pro",
    total_invites: "Total de convites",
    your_discount: "Seu desconto",
    no_pro_yet: "Nenhum ainda",
    copy_link: "Copiar link de convite",
    copied: "Link de convite copiado!",
    copy_failed: "Falha ao copiar link",
    invite_description: "Um amigo se cadastra com seu link",
    receive_credits: "Você ganha: 1 convite → 5% de desconto, 2 → 8%, 3 → 15%, 4+ → 20% · Cada amigo ganha 5% de desconto"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "PRO ATIVO",
    expires: "expira",
    free_plan: "PLANO GRATUITO",
    tagline: "Desbloqueie cotas completas de chat, sincronização de tarefas na nuvem e todos os recursos de papel de parede nesta extensão.",
    monthly: "MENSAL",
    yearly: "ANUAL",
    month_period: "/mês",
    year_period: "/ano",
    billed_monthly: "Cobrança mensal · cancele quando quiser",
    billed_yearly: "Cobrança anual",
    checkout_usd: "Cobrança",
    save_yearly: "Economize 17% vs mensal",
    best_value: "MELHOR VALOR",
    referral_price: "Preço de indicação",
    save: "economize",
    subscribe_now: "Assinar agora",
    current_plan: "Plano atual",
    processing: "Processando",
    waiting_title: "Aguardando pagamento",
    waiting_desc: "Conclua o pagamento na janela recém-aberta.",
    payment_completed: "Pagamento concluído",
    having_issues: "Tenho problemas",
    invite_save: "Convide amigos e economize no Pro",
    sign_in_first: "Faça login primeiro",
    checkout_failed: "Falha ao criar a sessão de pagamento",
    payment_failed: "Pagamento falhou",
    payment_wrong: "Algo deu errado. Tente novamente.",
    success_msg: "Parabéns! Pagamento concluído com sucesso",
    not_paid_msg: "O pagamento ainda não foi concluído. Conclua o pagamento na janela ou tente novamente.",
    verify_failed: "Falha ao verificar o status do pagamento. Tente novamente ou contate o suporte.",
    contact_email: "Contato por e-mail: hi@tabbyio.com"
  },
  about: {
    title: "Sobre",
    version: "Versão: 1.3.11",
    contact: "Contate-nos:",
    privacy_policy: "Política de Privacidade",
    terms_of_service: "Termos de Serviço"
  },
  tabs: {
    general: "Preferências",
    profile: "Perfil",
    wallpaper: "Papel de parede",
    rewards: "Recompensas",
    about: "Sobre"
  },
  language: {
    title: "Idioma",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "Favoritos",
    next_background: "Próximo fundo",
    ai_chat: "Chat com IA",
    search_placeholder: "Pesquise ou pressione Ctrl + Enter para chat com IA...",
    attach: "Anexar arquivo",
  },
  top_sites: {
    title: "Sites frequentemente visitados",
    error: "Não foi possível carregar os sites frequentemente visitados",
    empty: "Nenhum site frequentemente visitado encontrado"
  },
  greetings: {
    morning: "Bom dia",
    afternoon: "Boa tarde",
    evening: "Boa noite",
    morning_message: "Um novo dia começa, como posso ajudar você?",
    afternoon_message: "Hora da tarde, tem alguma pergunta para fazer?",
    evening_message: "Hora da noite, deixe-me conversar com você!"
  },
  intro: {
    your_portal: "Seu portal",
    for: "para",
    productivity: "produtividade.",
    inspiration: "inspiração.",
    photography: "fotografia.",
    description: "Onde cada nova aba se torna um portal",
    description_continued: "para elegância, produtividade e além.",
    add_to_chrome: "Adicionar ao Chrome",
    free: "Grátis",
    try_now: "Experimente agora",
    screenshot: "Captura de tela"
  }
}

